import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledWrapper = styled(Ds.Flex).attrs({
    flexDirection: "column",
    alignItems: "center",
    gap: "1.5",
})`
    padding: 1rem;
`;
